import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { usePathStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function PathGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function PathGridLayout() {
  return <GridProvider store={usePathStore()}>
    <PathGrid />
  </GridProvider>
}
